import { h, Component } from 'preact'
import PropTypes from 'prop-types'

import TabsHeaders from 'components/TabsHeaders'

import './index.sass'

export default class TabsMenu extends Component {
  static propTypes = {
    tabs: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.element.isRequired,
        href: PropTypes.string,
      })
    ).isRequired,
    defaultTabIndex: PropTypes.number,
    currentTabIndex: PropTypes.number.isRequired,
    onTabClick: PropTypes.func,
    className: PropTypes.string,
    headerSize: TabsHeaders.propTypes.size,
    fullWidth: TabsHeaders.propTypes.fullWidth,
  }

  static defaultProps = {
    defaultTabIndex: 0,
    className: '',
  }

  render() {
    const { tabs, onTabClick, className, headerSize, fullWidth } = this.props
    let currentTabIndex = this.props.currentTabIndex || this.props.defaultTabIndex || 0
    if (currentTabIndex > tabs.length - 1) currentTabIndex = tabs.length - 1
    const currentTab = tabs[currentTabIndex]
    let currentContent = currentTab.content
    if (typeof currentContent === 'function') currentContent = currentContent()
    return <div className={`TabsMenu ${className}`}>
      <TabsHeaders
        onTabClick={onTabClick}
        tabs={tabs}
        currentTabIndex={currentTabIndex}
        size={headerSize}
        fullWidth={fullWidth}
      />
      <div className="TabsMenu-content" key={currentTabIndex}>
        { currentContent }
      </div>
    </div>
  }
}
